import { createRoutesFromElements, redirect, Route } from 'react-router-dom';
import { RequireAuth } from 'components';
import Checkout from 'components/Checkout';
import LibraryLayout, { LibraryTracksLayout, LikedSongs } from 'pages/Library';
import LibraryProjects from 'pages/Library/components/LibraryStudioProjects';
import StudioSongList from 'pages/Library/components/StudioSongList/StudioSongList';
import { locations } from './locations';

const libraryRoutes = createRoutesFromElements(
  <Route
    id="library"
    path={locations.library.routeSegment}
    element={
      <RequireAuth>
        <LibraryLayout />
        <Checkout shouldBlockRedirect />
      </RequireAuth>
    }
  >
    <Route
      id="library-index"
      index
      loader={() => redirect(locations.library.tracks.route)}
    />
    <Route
      id="tracks"
      path={locations.library.tracks.route}
      element={<LibraryTracksLayout />}
    >
      <Route
        id="tracks-index"
        index
        loader={() => redirect(locations.library.tracks.liked.route)}
      />
      <Route
        id="liked"
        path={locations.library.tracks.liked.route}
        element={<LikedSongs />}
      />
      <Route
        id="studio-tracks-list"
        path={locations.library.tracks.studio.route}
        element={<StudioSongList />}
      />
    </Route>
    <Route
      id="projects"
      path={locations.library.projects.route}
      element={<LibraryProjects />}
    />
  </Route>
);

export default libraryRoutes;
